exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time-selection {\r\n  position: absolute;\r\n  right: 18px;\r\n  z-index: 300;\r\n  width: 200px;\r\n  height: 26px;\r\n  top: 15px;\r\n}\r\n\r\n.time-selection {\r\n  transition: right linear 0.25s;\r\n}\r\n\r\n.time-selection-move {\r\n  right: 450px;\r\n}\r\n\r\n.period-chooser {\r\n  position: absolute;\r\n  right: 18px;\r\n  overflow: hidden;\r\n  height: 30px;\r\n  z-index: 300;\r\n  width: 0px;\r\n}\r\n\r\n.period-chooser {\r\n  transition: width linear 0.25s;\r\n}\r\n\r\n.period-chooser-show {\r\n  width: 400px;\r\n}\r\n\r\n.date-input {\r\n  width: 110px;\r\n}\r\n\r\n.memberSelect {\r\n  font-size: 24px;\r\n  width: 300px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/group-details-statistics/group-details-statistics.component.css
// module id = ../../../../../src/app/components/group-details-statistics/group-details-statistics.component.css
// module chunks = 0